var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 165,
    viewBox: "0 0 289 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.498 2V9.98347",
    stroke: "#5FCEE7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.498 20.6289V28.6124",
    stroke: "#5FCEE7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.165 15.3054H203.165",
    stroke: "#5FCEE7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.833 15.3054H221.833",
    stroke: "#5FCEE7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1637 141.711V147.033",
    stroke: "#5FCEE7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1637 157.678V163",
    stroke: "#5FCEE7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.498 152.356H53.8314",
    stroke: "#5FCEE7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4976 152.356H69.8309",
    stroke: "#5FCEE7",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.608 129.736H58.3616C53.4987 129.736 49.5566 125.566 49.5566 120.422C49.5566 115.278 53.4987 111.108 58.3616 111.108H9.30503C4.44214 111.108 0.5 106.938 0.5 101.794C0.5 96.65 4.44214 92.48 9.30503 92.48H59.6195C64.4823 92.48 68.4245 88.3099 68.4245 83.1659C68.4245 78.0219 64.4823 73.8519 59.6195 73.8519H28.1729C23.3101 73.8519 19.3679 69.6819 19.3679 64.5378C19.3679 59.3938 23.3101 55.2238 28.1729 55.2238H78.4874C73.6245 55.2238 69.6824 51.0538 69.6824 45.9097C69.6824 40.7657 73.6245 36.5957 78.4874 36.5957H150.185C155.048 36.5957 158.99 40.7657 158.99 45.9097C158.99 51.0538 155.048 55.2238 150.185 55.2238H230.689C235.551 55.2238 239.494 59.3938 239.494 64.5378C239.494 69.6819 235.551 73.8519 230.689 73.8519H258.362C263.224 73.8519 267.167 78.0219 267.167 83.1659C267.167 88.3099 263.224 92.48 258.362 92.48H234.462C231.717 92.48 229.264 93.8093 227.65 95.8927H239.747C242.372 95.8927 244.5 98.4438 244.5 101.591C244.5 104.738 242.372 107.289 239.747 107.289H227.352C228.954 109.604 231.542 111.108 234.462 111.108H242.009C246.872 111.108 250.814 115.278 250.814 120.422C250.814 125.566 246.872 129.736 242.009 129.736H231.194C230.685 129.959 230.135 130.081 229.562 130.081H202.401C205.026 130.081 207.154 132.632 207.154 135.779C207.154 138.926 205.026 141.477 202.401 141.477L163.698 141.477C161.072 141.477 158.944 138.926 158.944 135.779C158.944 132.632 161.072 130.081 163.698 130.081H120.241C119.667 130.081 119.118 129.959 118.608 129.736ZM288.5 120.422C288.5 125.566 284.321 129.736 279.167 129.736C274.012 129.736 269.833 125.566 269.833 120.422C269.833 115.278 274.012 111.108 279.167 111.108C284.321 111.108 288.5 115.278 288.5 120.422Z",
    fill: "#83D9EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.166 75.8468C123.166 75.8468 111.167 28.6113 150.5 28.6113C189.833 28.6114 179.833 75.8468 179.833 75.8468M166.296 98.4667C174.953 90.0501 173.166 73.2511 173.166 59.8799C167.069 60.9444 159.07 53.6705 155.833 49.9006C151.566 61.0774 135.388 63.4281 127.833 63.2064C127.833 81.1692 129.166 103.789 150.5 103.789C157.875 103.789 162.892 101.776 166.296 98.4667ZM166.296 98.4667C166.586 101.571 169.7 107.648 179.833 107.115C192.499 106.45 201.833 116.429 202.499 127.739",
    stroke: "#20B3D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.166 96.4707C135.166 99.7971 133.033 106.45 124.499 106.45C113.833 106.45 100.499 114.434 99.166 127.074M167.833 111.772C166.499 112.438 163.433 113.901 161.833 114.434",
    stroke: "#20B3D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.166 115.098C151.166 117.76 133.833 116.828 131.166 105.119",
    stroke: "#20B3D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIllustration);
export default __webpack_public_path__ + "static/media/personIllustration.ef80abb7d19f14d437c35c42f2378d8f.svg";
export { ForwardRef as ReactComponent };